<template>
    <div class="processing-personal-data">
        <div class="header">
            <div class="title">Согласны на обработку персональных данных?</div>
            <div class="close" @click="reject"></div>
        </div>
        <div class="content">
            Нажимая на кнопку "Продолжить",
            Вы подтверждаете согласие на обработку персональных данных в соответствии с
            <a class="primary" download="УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ.pdf" href="TPDP.pdf" target="_blank">
                "Условиями обработки персональных данных"</a>.
        </div>
        <div class="buttons">
            <button class="primary action" @click="accept">
                <span class="text">Продолжить</span>
            </button>
            <button class="action close" @click="reject">
                <span class="text">Отмена</span>
            </button>
        </div>
    </div>
</template>

<script>
import { currentUser } from '@/common/session.js';
import { logout, processingAgreement } from '@/restapi/user/user.js';
import { Popup } from '@dsee/components/popups/popup.js';

export default {
    name: 'ProcessingPersonalData',
    async mounted() {
        this.$modal = new Popup({
            removeOnClose: true,
        }, this.$el);

        const user = currentUser();
        if (!user.processingAgreed) {
            this.open();
        } else {
            this.$destroy();
        }
    },
    methods: {
        open() {
            this.$modal.open();
        },
        close() {
            this.$modal.close();
        },
        async accept() {
            await processingAgreement(true);
            this.close();
        },
        async reject() {
            await logout();
            this.$router.push({ name: 'login' });
            this.close();
        },
    },
};
</script>

<style lang="scss" scoped>
.processing-personal-data {
    .content {
        a {
            display: contents;
        }
    }
}
</style>
